export type TurnContinuationReason = "time" | "checkpoint" | "workflow";
const TURN_CONTINUATION_LABEL: Record<TurnContinuationReason, string> = {
	checkpoint: "continued automatically — fact register checkpoint",
	time: "continued automatically — platform time budget",
	workflow: "continued automatically — workflow autopilot",
};

export function turnContinuationLabel(reason: TurnContinuationReason): string {
	return TURN_CONTINUATION_LABEL[reason];
}

export type TurnContinuationUiState = ReadonlyArray<{
	scheduledAt: number;
	reason: TurnContinuationReason;
}>;

export type TurnContinuationMarkerSpec = {
	index: number;
	reason: TurnContinuationReason;
	key: string;
};

/** Marker positions for a transcript, given each turn's creation timestamp. */
export function turnContinuationMarkers(
	itemTimestamps: ReadonlyArray<number | undefined>,
	continuations?: TurnContinuationUiState,
): TurnContinuationMarkerSpec[] {
	if (!continuations || continuations.length === 0) return [];
	const earliestLoaded = itemTimestamps.find(
		(timestamp): timestamp is number => typeof timestamp === "number",
	);
	if (earliestLoaded === undefined) return [];
	const markers: TurnContinuationMarkerSpec[] = [];
	for (const continuation of continuations) {
		if (continuation.scheduledAt < earliestLoaded) continue;
		const firstLaterItem = itemTimestamps.findIndex(
			(itemTime) =>
				typeof itemTime === "number" && itemTime > continuation.scheduledAt,
		);
		markers.push({
			index: firstLaterItem === -1 ? itemTimestamps.length : firstLaterItem,
			reason: continuation.reason,
			key: `${continuation.reason}:${continuation.scheduledAt}`,
		});
	}
	return markers;
}
